/* Paris Mall — comportements de la boutique : ajout au panier, favoris, quantité, visuels. */
(function () {
  'use strict';

  var routes = (window.PM && window.PM.routes) || {};
  var CART_ADD = (routes.cart_add_url || '/cart/add') + '.js';

  // ---- petit message passager ------------------------------------------------
  var timer;
  function message(texte) {
    var el = document.querySelector('.pm-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pm-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = texte;
    el.classList.add('is-on');
    clearTimeout(timer);
    timer = setTimeout(function () { el.classList.remove('is-on'); }, 2400);
  }

  function majCompteur(n) {
    document.querySelectorAll('.pm-js-cart-count').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  // ---- ajout au panier sans recharger la page -------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.pm-js-add-form, .pm-js-product-form');
    if (!form) return;
    e.preventDefault();
    var bouton = form.querySelector('button[type="submit"]');
    var ajoute = form.querySelector('.pm-add');
    fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { message(res.d.description || "Ce produit n'a pas pu être ajouté."); return; }
        if (ajoute) {
          ajoute.classList.add('is-added');
          var dit = form.parentElement.querySelector('[aria-live]');
          if (dit) dit.textContent = 'Ajouté au panier';
          setTimeout(function () { ajoute.classList.remove('is-added'); if (dit) dit.textContent = ''; }, 1600);
        } else if (bouton) {
          message('Ajouté au panier');
        }
        return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (panier) { majCompteur(panier.item_count); });
      })
      .catch(function () { message('Connexion interrompue : réessayez.'); });
  });

  // ---- quantité sur la fiche produit ----------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pm-js-qty');
    if (!btn) return;
    var form = btn.closest('form');
    var sortie = form.querySelector('.pm-js-qty-value');
    var champ = form.querySelector('.pm-js-qty-input');
    var n = Math.max(1, parseInt(sortie.textContent, 10) + parseInt(btn.dataset.step, 10));
    sortie.textContent = n;
    if (champ) champ.value = n;
    form.querySelector('.pm-js-qty[data-step="-1"]').disabled = n <= 1;
  });

  // ---- visuels de la fiche ---------------------------------------------------
  document.addEventListener('click', function (e) {
    var vignette = e.target.closest('.pm-js-thumb');
    if (!vignette) return;
    var grand = document.querySelector('.pm-pd__img');
    if (grand) grand.src = vignette.dataset.src;
    document.querySelectorAll('.pm-js-thumb').forEach(function (v) { v.classList.toggle('is-active', v === vignette); });
  });

  // ---- favoris : gardés dans ce navigateur -----------------------------------
  var CLE = 'pm.favoris';
  function favoris() {
    try { return JSON.parse(localStorage.getItem(CLE)) || []; } catch (err) { return []; }
  }
  function ecrire(liste) {
    try { localStorage.setItem(CLE, JSON.stringify(liste)); } catch (err) { /* navigation privée */ }
    document.querySelectorAll('.pm-js-fav-count').forEach(function (el) {
      el.textContent = liste.length;
      if (liste.length > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function peindre() {
    var liste = favoris();
    document.querySelectorAll('.pm-js-fav').forEach(function (b) {
      var actif = liste.indexOf(b.dataset.handle) >= 0;
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
      b.classList.toggle('is-on', actif);
    });
    ecrire(liste);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pm-js-fav');
    if (!b) return;
    var liste = favoris();
    var i = liste.indexOf(b.dataset.handle);
    if (i >= 0) liste.splice(i, 1); else liste.push(b.dataset.handle);
    ecrire(liste);
    b.setAttribute('aria-pressed', i >= 0 ? 'false' : 'true');
    b.classList.toggle('is-on', i < 0);
    b.classList.remove('is-pop');
    void b.offsetWidth;
    if (i < 0) b.classList.add('is-pop');
  });

  // ---- variantes : suivre le choix des options ------------------------------
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('pm-js-option')) return;
    var form = e.target.closest('form');
    var choisies = Array.prototype.map.call(form.querySelectorAll('.pm-js-option:checked'), function (i) { return i.value; });
    var produit = window.PM && window.PM.produit;
    if (!produit) return;
    var trouvee = produit.variants.find(function (v) {
      return choisies.every(function (val, idx) { return v.options[idx] === val; });
    });
    if (trouvee) {
      form.querySelector('.pm-js-variant').value = trouvee.id;
      var url = new URL(window.location);
      url.searchParams.set('variant', trouvee.id);
      window.history.replaceState({}, '', url);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', peindre); else peindre();
})();
